import { useState, useEffect } from 'react';

export const useScrollRestoration = (delay = 120) => {
  const [isRestored, setIsRestored] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsRestored(true);
    };

    window.addEventListener('scroll', handleScroll, { once: true, passive: true });

    const timer = setTimeout(() => {
      setIsRestored(true);
    }, delay);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      clearTimeout(timer);
    };
  }, [delay]);

  return isRestored;
};
